// createNewBrickModal.tsx

export const createBrickValidation = {
  brickName: {
    pattern: {
      value: /^(?!.*[^a-zA-Z0-9 ]).{5,}$/,
      message: "Enter correct Brick Name",
    },
  },
  workDays: {
    pattern: {
      value: /^[0-9]+$/,
      message: "Enter number only",
    },
  },
  
  distance: {
    pattern: {
      value: /^[0-9]+$/,
      message: "Only Number allowed",
    },
  },
  distanceFromBaseBrick: {
    pattern: {
      value: /^[0-9]+$/,
      message: "Only Number allowed",
    },
  },
  expectedBusiness: {
    pattern: {
      value: /^[0-9]+$/,
      message: "Enter number only",
    },
  },
};

// UpdateBrickModal.tsx

export const updateBrickValidation = {
  workDays: {
    pattern: {
      value: /^[0-9]+$/,
      message: "Enter number only",
    },
  },
  distance: {
    pattern: {
      value: /^[0-9]+$/,
      message: "Only Number allowed",
    },
  },
  distanceFromBaseBrick: {
    pattern: {
      value: /^[0-9]+$/,
      message: "Only Number allowed",
    },
  },
  expectedBusiness: {
    pattern: {
      value: /^[0-9]+$/,
      message: "Enter number only",
    },
  },
  otherReason: {
    pattern: {
      value: /^(?:[a-zA-Z0-9]+\s){1,}[a-zA-Z0-9]+$/,
      message: "Enter more than 1 words",
    },
  },
};
